module.exports = __webpack_public_path__ + "img/outpatient-increase-prescription.09ce5edb.svg";